export default {
    all: (state) => {
        let languages = state.all
        if (state.filters.length > 0) {
            languages = state.all.filter(x => state.filters.includes(x.value))
        }
        return JSON.parse(JSON.stringify(languages))
    },
    responses: (state) => {
        let languages = state.all
        if (state.filters.length > 0) {
            languages = state.all.filter(x => state.filters.includes(x.value))
        }
        languages = JSON.parse(JSON.stringify(languages))
        return [{
            name: 'languages',
            type: 'select',
            responses: languages,
            options: {}
        }]
    }
}
